/* eslint-disable react/no-unescaped-entities */
import { useMutation } from '@apollo/client';
import FormContainer from '@components/FormContainer';
import FormSection from '@components/FormSection';
import InputDate from '@components/InputDate';
import InputFieldControlled from '@components/InputFieldControlled';
import InputRichText from '@components/InputRichText';
import Popover from '@components/Popover';
import { useSnackbar } from '@components/Snackbar/SnackbarProvider';
import Text from '@components/Text';
// import Popover from '@components/PopOver';
import { UPDATE_DESCRIPTION_PRO } from '@gql/pros';
import { Stack } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { moment } from '@utils/date.utils';

type Props = {
    pro: any;
    onSuccess?: (data?: any) => void;
    onError?: (error?: any) => void;
    isEdit?: boolean;
    disabled?: boolean;
};

const CompanyAboutForm = (props: Props) => {
    const { enqueueSnackbar } = useSnackbar();

    const user = props?.pro;
    const [formState, setFormState] = useState<'view' | 'edit'>('view');

    const {
        control,
        handleSubmit,
        reset,
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            experience: user?.experience,
            description: user?.description,
            numberOfEmployees: user?.numberOfEmployees,
        },
    });


    const [update, { loading }] = useMutation(UPDATE_DESCRIPTION_PRO, {
        onError: err => {
            enqueueSnackbar(err.message, {
                variant: 'error',
            });
        },
        onCompleted: () => {
            enqueueSnackbar('Description modifiée avec succès', {
                variant: 'success',
            });
        },
    });

    const submitHandler = async data => {
        const request = {
            variables: {
                proId: user._id,
                experience: data?.experience ? new Date(data?.experience).toISOString() : null,
                description: data?.description,
                numberOfEmployees: data?.numberOfEmployees ? Number(data.numberOfEmployees) : null,
            },
        };

        await update(request);

        setFormState('view');
    };

    return (
        <FormContainer
            onBack={() => { }}
            formTitle="À propos de ma société"
            formDescription={'Décrivez ici votre établissement, vos services et points forts.'}
            loading={loading}
            formState={formState}
            setFormState={setFormState}
            hideEdit={props.disabled}
            onCancel={() => {
                reset();
            }}
            breadcrumbs={['Mes informations', 'A propos de ma société']}
            onSubmit={handleSubmit(submitHandler)}
            submitText={props.isEdit ? 'Enregistrer' : 'Suivant'}>
            <FormSection title="Informations sur votre société">
                <Stack direction="row" gap={2} alignItems="center">
                    <InputDate
                        viewOnly={formState === 'view'}
                        label="Nombre d'année d'existence"
                        placeholder="Nombre d'année d'existence"
                        name="experience"
                        control={control}
                        maxDate={moment().toDate()}
                        required
                        defaultValue={undefined}
                    />
                    <InputFieldControlled
                        viewOnly={formState === 'view'}
                        label="Nombre d'employés"
                        placeholder="Nombre d'employés"
                        name="numberOfEmployees"
                        control={control}
                        type="number"
                    />
                </Stack>
                <Stack style={{ width: '100%', position: 'relative' }}>
                    <InputRichText
                        viewOnly={formState === 'view'}
                        label="Description"
                        name="description"
                        placeholder={
                            "Présentez votre entreprise pour attirer les futurs talents. Ce contenu sera affiché sur l'ensemble de vos offres afin de valoriser votre marque employeur."
                        }
                        fullWidth
                        required
                        control={control}
                        defaultValue={undefined}
                        maxLength={1000}
                    />
                    <Popover
                        buttonStyle={{
                            position: 'absolute',
                            right: 0,
                            top: 0,
                        }}>
                        <Text dark bold size={16}>
                            Pensez à décrire dans ce bloc les éléments suivants de votre expérience.
                        </Text>
                        <Stack mt={1}>
                            <Text dark>Qui vous êtes</Text>
                            <Text dark>Vos diplomes</Text>
                            <Text dark>Ce que vous proposez</Text>
                            <Text dark>Vos spécialités</Text>
                            <Text dark>Vos expériences passées</Text>
                        </Stack>
                    </Popover>
                </Stack>
            </FormSection>
        </FormContainer>
    );
};

export default CompanyAboutForm;
